<div class="sidePanelAccountRow">
  <div class="sidePanelAccountRow__name" (click)="toggleAccount()">
    <pp-icon
      [ppSVG]="
        collapsed
          ? iconMap[EIconPath.ICON_NAV_ARROW_RIGHT_18]
          : iconMap[EIconPath.ICON_NAV_ARROW_DOWN_18]
      "
      ppClass="setSize18"
      ppColor="inherit"
    />

    <span
      class="sidePanelAccountRow__text"
      ppTooltip
      [ppTrimTooltip]="true"
      [ppTitle]="account.name"
    >
      {{ account.name }}
    </span>
  </div>

  @if (cogVisible) {
    <button
      (click)="toggleAccountOptionsDropdown()"
      ppTooltip
      [ppTitle]="'account_settings' | ppTranslate"
      class="sidePanelAccountCogButton"
      [id]="cogButtonId"
    >
      <pp-icon [ppSVG]="iconMap[EIconPath.ICON_NAV_COG_18]" ppClass="setSize18" ppColor="inherit" />
    </button>
  }
</div>
